import { atom } from "jotai";

export const ColumnSelectModalOpen = atom(false);
